import * as $ from 'jquery';
import { error } from 'jquery';
import { SdkInstallInfoDialog } from './angular_components/sdk-install-info-dialog/sdk-install-info-dialog';
import { SignErrorDialog } from './angular_components/sign-error-dialog/sign-error-dialog';

export const podpis = {
  callback: null,
  zaladowanieAppletuDeferred: null,
  task: null,
  silent: false,
  settings: null,
  cryptoAppletLibURI: null,
  cryptoAppletJarVersion: null,
  obslugaChromeAndFF52plus: true,
  dialogService: null,
  spinnerService: null,

  podpiszDokumentSilent: function (
    settings: any,
    task: any,
    dialogService: any,
    spinnerService: any,
    callback: any,
  ): void {
    this.callback = callback;
    this.task = task;
    this.silent = true;
    this.settings = settings;
    this.cryptoAppletLibURI = podpis.cryptoAppletLibURI;
    this.cryptoAppletJarVersion = podpis.cryptoAppletJarVersion;
    this.dialogService = dialogService;
    this.spinnerService = spinnerService;
    this.podpisz(task);
  },

  podpiszDokument: function (settings: any, task: any, callback: any): void {
    this.callback = callback;
    this.task = task;
    this.silent = false;
    this.settings = settings;
    this.cryptoAppletLibURI = podpis.cryptoAppletLibURI;
    this.cryptoAppletJarVersion = podpis.cryptoAppletJarVersion;
    this.podpisz(task);
  },

  podpisz: function (task: any): void {
    if (
      podpis.obslugaChromeAndFF52plus ||
      (!podpis.isChrome() && !podpis.isFF52plus())
    ) {
      this.podpiszDane(task);
    } else {
      var message =
        'Twoja przeglądarka nie obsługuje Javy.\nUpewnij siê, ¿e na Twoim komputerze zainstalowana jest Java oraz jej obsługa jest włączona w przeglądarce.';
      error(message);
    }
  },

  podpiszDane: function (task: any): void {
    function _podpiszDane(zadaniePodpisu: any): void {
      // console.log('_podpiszDane');
      // @ts-ignore
      var df = new $.Deferred();
      try {
        function resolve(podpisaneDane: any): void {
          df.resolve(podpisaneDane);
        }
        function reject(error: any): void {
          df.reject(error);
        }

        setTimeout(function () {
          if (podpis.silent) {
            (<any>window).SZAFIR_SDK.doTaskListNoWindow(
              zadaniePodpisu,
              resolve,
              reject,
            );
          } else {
            (<any>window).SZAFIR_SDK.doTaskList(
              zadaniePodpisu,
              resolve,
              reject,
            );
          }
        }, 1);
      } catch (e) {
        console.error('wystapil blad podczas uruchamiania appletu', e);
        df.reject('wystapil blad podczas uruchamiania appletu');
      }
      // console.log('_podpiszDane done');
      return df;
    }

    function _zalogujPodpis(wynikPodpisania: any): void {
      // console.log('_zalogujPodpis');
      // @ts-ignore
      podpis.callback(wynikPodpisania);
      // console.log('_zalogujPodpis done');
    }

    function _sprobujPodpisacErrorHandler(error: any): void {
      console.error(error);
      podpis.zaladowanieAppletuDeferred = null;
      podpis.bladPodpisu();
      if (error != null && error.includes('Host nie został uruchomiony')) {
        podpis.podpiszDane(null);
      }
    }

    try {
      // console.log('podpisz dane');
      podpis
        .sprawdzWtyczkeJava()
        .then(podpis.dodajApplet.bind(null))
        .then(_podpiszDane.bind(null, task))
        .then(_zalogujPodpis)
        .fail(_sprobujPodpisacErrorHandler);
    } catch (err) {
      // console.log('err');
      podpis.obslugaBlednejWersjiPrzegladarki(err);
    }
  },

  sprawdzWtyczkeJava: function (): any {
    // console.log('sprawdzWtyczkeJava');
    // @ts-ignore
    var df = new $.Deferred();

    if (podpis.isChrome() && !(window as any).SZAFIR_SDK.isExtInitialized()) {
      podpis.brakJavy();
      // df.reject(podpisHelper.komunikatNotExtInitialized);
    }

    if (
      podpis.isFF52plus() &&
      !window.navigator.javaEnabled() &&
      !(window as any).SZAFIR_SDK.isExtInitialized()
    ) {
      podpis.brakJavy();
      // df.reject(podpisHelper.komunikatFFNotExtInitialized);
    }

    setTimeout(function () {
      if (
        (window as any).SZAFIR_SDK.isModeApplet() &&
        !window.navigator.javaEnabled()
      ) {
        alert(
          'W celu wykonania podpisu wymagane jest włączenie wtyczki Javy w przeglądarce',
        );
        df.reject(
          (window as any).SZAFIR_MESSAGES.ERROR.NIEAKTYWNA_WTYCZKA_JAVA,
        );
      } else {
        df.resolve();
      }
    }, 1);

    // console.log('sprawdzWtyczkeJava done');
    return df.promise();
  },

  brakJavy: function (): void {
    //implementacja dla Angulara
    // @ts-ignore
    const ref = this.dialogService.open(SdkInstallInfoDialog, {
      closable: true,
      header: `Błąd podpisu`,
      closeOnEscape: true,
      modal: true,
      dismissableMask: true,
      width: '60vw',
      breakpoints: {
        '960px': '75vw',
        '640px': '95vw',
      },
    });
  },

  bladPodpisu: function (): void {
    // @ts-ignore
    this.spinnerService.hide();
    // @ts-ignore
    const ref = this.dialogService.open(SignErrorDialog, {
      closable: true,
      header: `Błąd wtyczki Szafir SDK Chrome Host`,
      closeOnEscape: true,
      modal: true,
      dismissableMask: true,
      width: '60vw',
      breakpoints: {
        '960px': '75vw',
        '640px': '95vw',
      },
    });
  },

  dodajApplet: function (): void {
    // console.log('dodajApplet');

    var _this = this;

    if (!podpis.zaladowanieAppletuDeferred) {
      // console.log('zaladowanieAppletuDeferred');

      // @ts-ignore
      podpis.zaladowanieAppletuDeferred = new $.Deferred();

      function _onErrorNoExtension(error: any, info: any): void {
        console.error('Brak rozszerzenia Szafir SDK', error);
        // @ts-ignore
        podpis.zaladowanieAppletuDeferred.reject(
          (window as any).SZAFIR_MESSAGES.ERROR.BRAK_ROZSZERZENIA_CHROME,
        );
      }

      function _onErrorNoHostApp(error: any, info: any): void {
        // console.log((window as any).SZAFIR_MESSAGES);
        if (error === 'NOT_INSTALLED') {
          console.error('Brak aplikacji Szafir HOST', error);
          podpis.brakJavy();
          // podpis.zaladowanieAppletuDeferred.reject(window.SZAFIR_MESSAGES.ERROR.BRAK_ROZSZERZENIA_CHROME);
          // podpisDialog.showPodpisDialog("Informacja", podpisHelper.komunikatNotAppInitialized);
          // err_apl = window.SZAFIR_MESSAGES.ERROR.BRAK_APLIKACJI_SZAFIR_HOST;
          // podpis.zaladowanieAppletuDeferred.reject(err_apl);
        } else {
          console.error(
            'Brak lub niaktualna wersja aplikacji Szafir HOST',
            error,
          );
          podpis.brakJavy();
          // podpis.zaladowanieAppletuDeferred.reject(window.SZAFIR_MESSAGES.ERROR.BRAK_ROZSZERZENIA_CHROME);
          // podpisDialog.showPodpisDialog("Informacja", "Brak lub niaktualna wersja aplikacji Szafir HOST");
          // var err_apl = (error === 'NOT_UPDATED' ? window.SZAFIR_MESSAGES.ERROR.NIEAKTUALNA_WERSJA_APLIKACJI_SZAFIR_HOST : window.SZAFIR_MESSAGES.ERROR.BRAK_APLIKACJI_SZAFIR_HOST);
          // podpis.zaladowanieAppletuDeferred.reject(err_apl);
        }
      }

      var config = {
        debug: false,
        versions_file: 'versions.xml',
        onErrorNoExtension: _onErrorNoExtension,
        onErrorNoHostApp: _onErrorNoHostApp,
        sdk_location_url: window.location.origin + '/szafir/lib/',
      };
      // console.log('set config');
      // console.log(config);

      (window as any).SZAFIR_SDK.config(config);

      function _appletInit(): void {
        setTimeout(function () {
          // console.log('start component');
          (window as any).SZAFIR_SDK.startComponent(
            podpis.settings,
            _startComponentCallback,
            _startComponentErrorCallback,
          );
        }, 1);

        function _startComponentCallback(): void {
          // console.log('komponent zostal uruchomiony');
          // @ts-ignore
          podpis.zaladowanieAppletuDeferred.resolve();
        }

        function _startComponentErrorCallback(e: any): void {
          console.error('blad podczas uruchamiania komponentu szafir', e);
          // @ts-ignore
          podpis.zaladowanieAppletuDeferred.reject(e);
        }
      }

      function _appletInitError(e: any): void {
        console.error('blad podczas inicjalizacji komponentu szafir', e);
        // @ts-ignore
        podpis.zaladowanieAppletuDeferred.reject(e);
      }

      // console.log('loadSzafir');
      (window as any).SZAFIR_SDK.loadSzafir(_appletInit, _appletInitError);
      // console.log('loadSzafir done');
    }

    // console.log('dodajApplet done');
    // @ts-ignore
    return podpis.zaladowanieAppletuDeferred.promise();
  },

  obslugaBlednejWersjiPrzegladarki: function (err: any): void {
    podpis.zaladowanieAppletuDeferred = null;

    if (
      err != undefined &&
      err.message == "Object doesn't support property or method 'bind'"
    ) {
      alert(
        'Do poprawnego działania podpisu jest wymagana jedna z przeglądarek: Internet Explorer 9+, Firefox 16+, Chrome 20+',
      );
    } else if (err != undefined) {
      alert(
        'Błąd podpisu. Wiadomość:' + err.message + ', Opis: ' + err.description,
      );
    } else {
      alert('Błąd podpisu');
    }
  },

  isChrome: function (): boolean {
    return (
      /Chrome/.test(navigator.userAgent) && /Google Inc/.test(navigator.vendor)
    );
  },

  isFF52plus: function (): boolean {
    var navUA = navigator.userAgent.toLowerCase();

    //szukamy Firefoxa w wersji >= 52
    var m = navUA.match(/\bfirefox\/(\d+)/);
    if (m != null) {
      return parseInt(m[1]) >= 52;
    }

    return false;
  },
};
